import { Form, Formik } from 'formik';
import { NewModal } from 'lib/components';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { Flex, Gap } from 'lib/components/styles/layout';
import { useAuth } from 'lib/context';
import React from 'react';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

type SendReportModalProps = {
  onModalClose: () => void;
  onSendReport: (recipients: string[]) => void;
  isSending?: boolean;
};

type SendReportInitialValues = {
  recipient: string;
};

const SendReportModal = ({
  onModalClose,
  onSendReport,
  isSending,
}: SendReportModalProps) => {
  const { userData } = useAuth();
  const { t } = useTranslation();

  const initialValues = {
    recipient: userData.email,
  };

  const validationSchema = Yup.object({
    recipient: Yup.string()
      .required()
      .min(1, t('Recipient cannot be empty!'))
      .email(t('Please type in a proper email address.')),
  });

  const onSubmit = (values: SendReportInitialValues) => {
    onSendReport([values.recipient]);
  };

  return (
    <NewModal closeModal={onModalClose} headerText={t('Send Report')}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validateOnMount
        validationSchema={validationSchema}
      >
        {({ handleSubmit, isValid }) => {
          return (
            <Form>
              <Flex gap='20px'>
                <FormikInputField
                  name='recipient'
                  isRequired
                  label={t('Recipients')}
                  disabled={isSending}
                />

                <Gap gap='8px' justifyContent='flex-end'>
                  <Button
                    text={t('Cancel')}
                    onClick={onModalClose}
                    variant='secondary'
                    disabled={isSending}
                  />
                  <Button
                    text={isSending ? t('Sending...') : t('Send')}
                    onClick={() => handleSubmit()}
                    disabled={!isValid || isSending}
                  />
                </Gap>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </NewModal>
  );
};

export default SendReportModal;
